import React from 'react';
import { Grid, CssBaseline, Typography } from '@material-ui/core';
import { PersonProfileNavbar } from '../../components/personProfileNavbar/personProfileNavbar';
import { useTranslation } from 'react-i18next';
import { useRegistrationsStyles } from './style';
import MaterialTable from 'material-table';
import { CertificationModel } from '../../models/certificationModel';
import { getCertificationsReq } from '../../api/person/certificationApi';
import { CertificateFamilies } from '../../models/eums/certification/certificateFamilies';
import { CertificateTypesRegistration } from '../../models/eums/certification/certificateTypesRegistration';
import moment from 'moment';
import { localization } from 'config/localization';

export function Registrations() {
  const style = useRegistrationsStyles();
  const { t } = useTranslation();

  async function getRegistrations() {
    let dataSet: CertificationModel[] = [];

    const resp = await getCertificationsReq(
      CertificateFamilies.REGISTRATION,
      CertificateTypesRegistration.MEMBERSHIP,
    );
    if (resp && resp.data) dataSet = resp.data;

    return {
      data: dataSet,
      page: 0,
      totalCount: dataSet.length,
    };
  }

  return (
    <Grid container>
      <CssBaseline />
      <PersonProfileNavbar selectedIndex={3} />
      <Grid container item>
        <Grid item container>
          <Grid item xs={12} className={style.titleBox}>
            <Typography variant='h5' className={style.titleText}>
              {t('registrations')}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <MaterialTable
              options={{
                pageSize: 10,
                showTitle: false,
                toolbar: false,
                headerStyle: {
                  fontWeight: 'bold',
                  backgroundColor: '#F5F5F5',
                },
              }}
              localization={localization()}
              columns={[
                {
                  title: t('type'),
                  field: 'type',
                },
                {
                  title: t('issued-date'),
                  field: 'certValidity.from',
                  render: val => moment(val.certValidity?.from).format('DD.MM.YYYY'),
                },
                {
                  title: t('expiry-date'),
                  field: 'certValidity.to',
                  render: val => moment(val.certValidity?.to).format('DD.MM.YYYY'),
                },
              ]}
              data={getRegistrations}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
